import React, { useEffect, useState } from "react";
import "../styles/testimonial.scss";
import testimonial1 from "../assets/Testimonials/Minister.png";
import testimonial2 from "../assets/Testimonials/Suresh Babu.png";
import testimonial3 from "../assets/Testimonials/Chandrasekar.png";
import testimonial4 from "../assets/Testimonials/Ranjitha.png";
import testimonial5 from "../assets/Testimonials/Palanisamy.png";
import testimonial6 from "../assets/Testimonials/Thamarai Selvan.png";

const testimonials = [
  {
    image: testimonial1,
    name: "Dr. Govi. Chezhiaan",
    title: "(Hon’ble Minister for Higher Education, Tamil Nadu)",
    text: `If we are to move forward as a society, it is essential to identify and analyse the underlying causes of these problems and the obstacles we face in addressing them. In this context, the effort to engage with such critical questions deserves recognition. The fact that PEN acknowledges and celebrates this kind of meaningful research is deeply significant.`,
  },
  {
    image: testimonial2,
    name: "Dr. M. Suresh Babu",
    title: "(Director of the Madras Institute of Development Studies)",
    text: `PEN Scholar Awards is a profound and one-of-a-kind initiative, because the field of Social Sciences is getting marginalised and social scientists are becoming a shrinking tribe, but the relevance of Social Sciences is at its maximum.`,
  },
  {
    image: testimonial3,
    name: "Dr. D. Chandrasekar",
    title: "(Winner – Social Sciences Category)",
    text: `The PEN Scholar Award provides a much-needed recognition to the field of Social Sciences. As a first-generation graduate from a village, receiving this award is not just a personal achievement but a significant milestone in my academic journey. This initiative must continue, as it will inspire and encourage future scholars to pursue impactful research, knowing that their hard work and contributions will be acknowledged and celebrated.`,
  },
  {
    image: testimonial4,
    name: "Dr. R. Ranjitha",
    title: "(Winner – Gender Studies Category)",
    text: `Writing a thesis demands immense dedication, often taking six to eight months of rigorous effort. I sincerely thank the PEN team for recognizing this hard work and honoring scholars through initiatives like this. I look forward to seeing many more such programs in the future.`,
  },
  {
    image: testimonial5,
    name: " Dr. C. Palanisamy",
    title: "(One of the top 5 nominees)",
    text: `I am honored that my thesis has been selected among the top five. Too often, Ph.D. theses remain idle in libraries, going unrecognized. However, the PEN Scholar Award has rightly acknowledged the hard work of Social Science researchers. Their transparent and anonymous evaluation process ensures fair recognition, making this initiative truly commendable. This award will inspire many scholars in the field, and I sincerely hope it continues to uplift and motivate future researchers.`,
  },
  {
    image: testimonial6,
    name: "Dr. Thamarai Selvan K",
    title: "(One of the top 5 nominees)",
    text: `Thank you, PEN Awards, for this incredible opportunity. It is truly heartening to see such an initiative to appreciate budding researchers in Social Sciences. I sincerely hope this initiative continues in the coming years, providing a platform for more theses to be recognized and presented before a larger audience`,
  },
];

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 2) {
    groupedTestimonials.push(testimonials.slice(i, i + 2));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        if (prev === groupedTestimonials.length - 1) {
          return 0; 
        } else {
          return prev + 1; 
        }
      });
    }, 10000);
  
    return () => clearInterval(interval);
  }, [groupedTestimonials.length]);
  

  return (
    <div className="testimonial-container">
      <h1>Testimonials</h1>
      <div className="slider-wrapper">
        <div
          className="testimonial-slider"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
            transition:
              currentIndex === 0 ? "none" : "transform 0.8s ease-in-out",
          }}
        >
          {groupedTestimonials.map((group, idx) => (
            <div className="testimonial-slide" key={idx}>
              {group.map((testimonial, i) => (
                <div className="testimonial-card" key={i}>
                  <div className="testimonial-header">
                    <img src={testimonial.image} alt={testimonial.name} />
                    <div>
                      <h2>{testimonial.name}</h2>
                      <h4>{testimonial.title}</h4>
                    </div>
                  </div>
                  <p className="testimonial-text">“{testimonial.text}”</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
